<span class="tag">{{label}}</span>